<template>
  <div class="currency-settings-modal">
    <el-dialog
      :visible="dialogDisplay"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      @close="closeModal"
      :width="'620px'">
      <template #title>
        <div class="dialog-title-box">
          <span>{{$t('message.index.currencySettings')}}</span>
          <rhcn-button
            class="icon-button dialog-close-icon"
            size="small"
            @click="dialogDisplay = false"
          ><i class="el-icon-close"></i></rhcn-button>
        </div>
      </template>
      <div v-loading="dataLoading" class="currency-settings-content-box">
        <div class="margin-bottom-20">
          <span class="margin-right-20 select-currency-title">{{$t('message.index.selectCurrencySettings')}}</span>
        </div>
        <div class="currency-settings-content">
          <div v-for="(item, index) in balances" :key="index" class="currency-settings-content-item">
            <el-image fit="scale-down" class="currency-img"  :src="getCurrencyImage(item.currency) ? require(`@/assets/images/currency/${item.currency}.png`) : ''"></el-image>
            <div class="currency-info margin-left-13">
              <p class="currency">{{item.currency}}</p>
              <p class="name">{{getCurrencyDesc(item.currency)}}</p>
            </div>
            <div v-if="!isShowHide(item)" class="not-hide margin-right-10">{{$t('message.index.currencyNotHidingTips')}}</div>
            <el-switch :value="item.checked" :disabled="!isShowHide(item)" @change="handleSwitchChange(item)"></el-switch>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import RhcnButton from '@/components/form/button.vue';
import { getCurrencyImage } from '@/utils/tools/currency';

export default {
  name: 'RechargeModal',
  components: {
    RhcnButton,
  },
  props: {
    balances: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      dialogDisplay: false,
      dataLoading: false,
    };
  },
  methods: {
    getCurrencyImage,
    getCurrencyDesc(currency) {
      if (!currency) {
        return '';
      }
      const desc = this.$t(`message.currencyDesc.${currency}`);
      if (!desc || desc.indexOf('message') > -1) {
        return '';
      }
      return desc;
    },
    openModal() {
      this.dialogDisplay = true;
    },
    closeModal() {
      this.dialogDisplay = false;
    },
    isShowHide(item) {
      if (item.totalBalance && item.totalBalance.amount && (+(+item.totalBalance.amount).toFixed(2)) !== 0) {
        return false;
      }
      return true;
    },
    handleSwitchChange(item) {
      console.log(item);
      item.checked = !item.checked;
      this.$emit('change', item);
    },
  },
};
</script>

<style lang="scss" scope>
@import '@/styles/variables.scss';
.currency-settings-modal {
  .el-dialog__body {
    display: flex;
    justify-content: center;
    padding: 0 30px;
    padding-top: 20px;
  }

  .currency-settings-content-box {
    width: 100%;
    // height: 410px;
    overflow-y: scroll;

    .select-currency-title {
      font-weight: 400;
      font-size: 14px;
      color: $color-text-primary;
      line-height: 20px;
    }

    .recharge-currency-select {
      width: 120px;

      .el-input__inner {
        font-weight: bold;
        color: $color-text-primary;
        background-color: white;
      }

      .el-icon-arrow-up {
        color: $color-text-primary;
      }
    }

    .currency-settings-content {
      border-radius: 2px;
      padding-bottom: 12px;

      .currency-settings-content-item {
        height: 60px;
        background: #F1F5F7;
        border-radius: 8px 8px 8px 8px;
        margin-bottom: 10px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        padding-left: 10px;
        padding-right: 15px;

        .currency-img {
          width: 30px;
          height: 30px;
        }
        .currency-info {
          flex: 1;
          font-size: 14px;
          color: $color-text-primary;
          line-height: 20px;
          .currency {
            font-weight: 900;
          }
          .name {
            font-weight: 400;
          }
        }
        .not-hide {
          font-weight: 400;
          font-size: 14px;
          color: $color-text-primary;
          line-height: 25px;
          text-align: center;
          min-width: 262px;
        }
      }

      .currency-settings-content-title {
        font-weight: bold;
        font-size: 14px;
        color: $color-text-primary;
        line-height: 20px;
      }

      .currency-settings-content-descriptions {
        margin-top: 15px;
        .el-descriptions__body {
          background-color: transparent;

          .el-descriptions-item__label  {
            font-weight: 400;
            font-size: 14px;
            color: $color-text-primary;
            line-height: 20px;

            .icon-copy {
              color: $color-success;
              font-size: 12px;
              cursor: pointer;
            }
          }

          .el-descriptions-item__content {
            color: $color-text-primary;
            word-break: break-all;
            font-weight: 800;
            line-height: 28px;
            font-size: 14px;
            font-family: Avenir-Heavy, Avenir;
            margin-right: 20px;
          }
        }
      }
    }

    .recharge-bottom-tips {
      font-weight: 400;
      font-size: 14px;
      color: $color-text-primary;
      line-height: 20px;
      margin-top: 10px;
      margin-bottom: 24px;
    }
  }

  .el-dialog__header{
    height: 64px;
    padding: 0;
    padding-left: 30px;
    padding-right: 20px;
    border-bottom: 1px solid rgba(0,32,63,0.08);
    font-size: 20px;
    font-family: Avenir-Heavy, Avenir;
    font-weight: 800;
    color: $color-text-primary;
    line-height: 36px;
  }

  .dialog-title-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;

    .dialog-close-icon {
      font-size: 23px;
      width: 27px !important;
      height: 27px !important;
      min-width: 27px !important;
      border-radius: 4px;
      cursor: pointer;
      span {
        display: inline-block;
        width: 20px;
        height: 20px;
        display: flex;
      }

      .el-icon-close {
        font-weight: bold;
        font-size: 20px;
        display: inline-block;
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>
